module.exports = __webpack_public_path__ + "static/img/demo-header_600.fb6d970.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/demo-header_600.png
// module id = UcMa
// module chunks = 0